import { useEffect } from 'react';
import { log } from 'log';
import { prop } from 'ramda';
import { useIsAdmin } from 'js/hooks/user';
import { useSportsbookSelector } from 'js/store/hooks';

import * as helpers from '../helpers';

export const useUnmountSportsbook = () => {
    const isAdmin = useIsAdmin();
    const isAppInitialized = useSportsbookSelector(prop('isAppInitialized'));

    useEffect(() => () => {
        if (isAdmin && isAppInitialized) {
            helpers.toggleCustomizationButton();
        }

        try {
            if (isAppInitialized) {
                if (window.Sportsbook.isMounted) {
                    window.Sportsbook.unmountSportsbook();
                }
            }
        } catch (error) {
            log('log', '[SPORTSBOOK | Portal] Unmount sportsbook app error', error);
        }
    }, [isAdmin, isAppInitialized]);
};
